/* eslint-disable no-undef */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Center from '@zg-rentals/multibrand-ui/lib/Center';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import sharedConfig from '../../../../sharedConfig';

class SuccessPage extends React.Component {
  render() {
    const { brand } = this.props;
    let homePage = sharedConfig.brandUrls[brand];
    if (brand === sharedConfig.brands.zillow) {
      homePage = `${homePage}/renting`;
    }

    return (
      <div className="SuccessPage">
        <Center>
          <div className="stacked-lg" />
          <Text type="h3" className="stacked-md">
            Thanks for giving your opinion!
          </Text>
          <Text className="stacked-md">
            We really appreciate your review. Sharing thoughts about what went well or what went wrong with your
            experience helps others with their search.
          </Text>
          <Text className="stacked-lg">Your review is being looked over by our moderators and will go live soon.</Text>
          <Button
            type="primary"
            onClick={() => {
              window.location = homePage;
            }}
          >
            Search for more homes
          </Button>
        </Center>
      </div>
    );
  }
}

SuccessPage.propTypes = {
  brand: PropTypes.string,
};

const mapStateToProps = (state) => ({
  brand: state.app.brand,
});

export default connect(mapStateToProps)(SuccessPage);
